import es from "date-fns/locale/es";
import { useFormik } from "formik";
import moment from "moment";
import { useCallback, useRef, useState } from "react";
import { Alert } from "react-bootstrap";
import Accordion from 'react-bootstrap/Accordion';
import DatePicker, { registerLocale } from 'react-datepicker';
// import DatePicker from 'react-date-picker';
import numeral from 'numeral';
import ReactNumeric from 'react-numeric';
import { useQuery, useQueryClient } from "react-query";
import { useParams } from "react-router-dom";
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { PageTitle } from "../../../../../_metronic/layout/core";
import { Loading } from "../../../../Components/Loading/Loading";
import UploadZone from "../../../../Components/Upload/UploadZone";
import { useGetUser } from "../../../../Hooks/CustomHooks";
import { GetAllTiposExcepcion, GetGarantiaDetalleFullById, GetMonedaList, SaveFarantiaExcepcion, UploadSustentoExcepcionGarantia } from "../../../../api/Api";
import PermissionsGate from "../../../../api/PermissionsGate";
import { SCOPES } from "../../../../config/permissions-map";
import { Unauthorized } from "../../../Global/unauthorized";
import { GARANTIA_TIPO } from "../../../Utils/Constants";
import './ExcepcionGarantia.css';

export default function ExcepcionGarantia({ title }) {

  const [isLoading, setIsLoading] = useState(false);
  const [isFinishSave, setIsFinishSave] = useState(false);
  const [messageError, setMessageError] = useState("");
  const [urlFileExcepcion, setUrlFileExcepcion] = useState("");
  const [fileNameExcepcion, setFileNameExcepcion] = useState("");
  const [file, setFile] = useState(null);
  const [showMessageUploadLink, setShowMessageUploadLink] = useState(false);
  const [isDisabledButtonSave, setIsDisabledButtonSave] = useState(false);
  const [isDisabledFormInput, setIsDisabledFormInput] = useState(false);


  const { id } = useParams();
  const queryClient = useQueryClient();
  const user = useGetUser();

  const idGarantiaExcepcion = useRef(null)
  const idGarantiaDetalle = useRef(null)

  registerLocale('es', es);

  // const {
  //   data: moneyListQuery,
  // } = useQuery("getMonedaList", async () => {
  //   try {
  //     let result = null;
  //     result = await GetMonedaList();

  //     return result.data.map((option) => ({
  //       value: option.id_moneda,
  //       label: option.codigo,
  //     })) || [];

  //   } catch (error) {
  //     console.log(error);
  //   }
  // });

  const transformOption = useCallback((array, valueKey, labelKey) => {
    return array.map(item => ({
      value: item[valueKey],
      label: item[labelKey]
    })) || [];
  }, []);

  const getDefaultOption = useCallback((defaultValue, list) => {
    if (defaultValue && list.length > 0) {
      const item = list.find(item => item.label === defaultValue);
      return { value: item.value, label: item.label }
    } else {
      return { value: "", label: "" }
    }
  }, [])

  const {
    data: initDataExceptionQuery,
    isFetching: isFetchingInitDataException,
  } = useQuery(["initDataException", id], async ({ queryKey }) => {
    try {
      const id = queryKey[1];
      let result = null;
      result = await GetGarantiaDetalleFullById(id);

      let getExceptionTypeList = await GetAllTiposExcepcion();

      idGarantiaExcepcion.current = result.data.detalle_garantia.excepcion.id_garantia_excepcion;
      idGarantiaDetalle.current = result.data.detalle_garantia.id_garantia_detalle;

      let monedaList = await GetMonedaList();
      const formatSelectMonedaList = transformOption(monedaList.data, "id_moneda", "codigo");


      if (result.data.detalle_garantia.excepcion.id_garantia_excepcion) {

        setFormikFieldValue("tipoExcepcion",
          {
            value: result.data.detalle_garantia.excepcion.codigo_tipo_excepcion,
            label: result.data.detalle_garantia.excepcion.nombre_tipo_excepcion
          }
        )
        setFormikFieldValue("importe", result.data.detalle_garantia.excepcion.importe);
        setFormikFieldValue("motivo", result.data.detalle_garantia.excepcion.motivo);
        setFormikFieldValue("fechaLimite", result.data.detalle_garantia.excepcion.fecha_vencimiento ? new Date(result.data.detalle_garantia.excepcion.fecha_vencimiento) : null);
        setFormikFieldValue("moneda", getDefaultOption(result.data.detalle_garantia.excepcion.codigo_moneda, formatSelectMonedaList));
        setFormikFieldValue("numfactura", getDefaultOption(result.data.detalle_garantia.excepcion.numero_factura ?? ''))
        setFileNameExcepcion(result.data.detalle_garantia.excepcion.file_name_adjunto);
        setUrlFileExcepcion(result.data.detalle_garantia.excepcion.url_file_name_adjunto);

        setShowMessageUploadLink(true);
      }
      if (result.data.detalle_garantia.tipo_garantia.codigo === GARANTIA_TIPO.GAR1_CARTA_FIANZA) {
        getExceptionTypeList.data = getExceptionTypeList.data.filter(item => item.codigo !== "ECF");
      }
      if (result.data.detalle_garantia.tipo_garantia.codigo === GARANTIA_TIPO.GAR0_EFECTIVO) {
        getExceptionTypeList.data = getExceptionTypeList.data.filter(item => item.codigo !== "CFE");
      }

      getExceptionTypeList.data = getExceptionTypeList.data.map(item => ({
        value: item["codigo"],
        label: item["nombre"]
      })) || [];



      return {
        garantia: result.data.garantia,
        detalleGarantia: result.data.detalle_garantia,
        exceptionTypeList: getExceptionTypeList.data,
        monedaList: formatSelectMonedaList
      };
    } catch (error) {
      console.log(error);
    }
  }, {
    enabled: !!id
  });

  const validateForm = useCallback((values) => {
    const errors = [];

    if (!values.tipoExcepcion) {
      errors.push({ field: 'Tipo Excepción', message: 'Debe ingresar un Tipo de Excepción' });
    }
    if (!values.importe) {
      errors.push({ field: 'Importe', message: 'Debe ingresar un Importe' });
    }
    if (!values.motivo) {
      errors.push({ field: 'Motivo', message: 'Debe ingresar un Motivo' });
    }
    if (!values.fechaLimite) {
      errors.push({ field: 'Fecha de Vencimiento', message: 'Debe ingresar una Fecha de Vencimiento' });
    }
    if (!values.moneda) {
      errors.push({ field: 'Moneda', message: 'Debe ingresar una Moneda' });
    }
    if (!urlFileExcepcion && !file) {
      errors.push({ field: 'Adjunto', message: 'Debe subir un archivo de sustento para la excepción' });
    }
    if (values.tipoExcepcion?.value === 'ECF' && (!values.numfactura || values.numfactura === '')) {
      errors.push({ field: 'N° Factura', message: 'Debe ingresar el número de factura' });
    }

    return errors;
  }, [file, urlFileExcepcion]);

  const { values: formikValues,
    setFieldValue: setFormikFieldValue,
    handleSubmit: handleSubmitFormik,
    errors: formikErrorList,
    setErrors: setFormikErrorList } = useFormik({
      initialValues: {
        tipoExcepcion: null,
        importe: "",
        motivo: "",
        fechaLimite: null,
        moneda: null
      },
      enableReinitialize: true,
      onSubmit: (values) => {
        setIsFinishSave(false);
        setIsLoading(true);

        const errorList = validateForm(values);
        if (errorList.length === 0) {
          const obj = {
            "id_garantia_excepcion": idGarantiaExcepcion.current,
            "id_garantia_detalle": idGarantiaDetalle.current,
            "codigo_tipo_excepcion": values.tipoExcepcion.value,
            "importe": values.importe,
            "motivo": values.motivo,
            "id_moneda": values.moneda.value,
            "numero_factura": values.numfactura,
            "fecha_vencimiento": moment(values.fechaLimite).toISOString(),
            "updated_by": user.email
          }

          queryClient.fetchQuery('saveFarantiaExcepcion',
            () => SaveFarantiaExcepcion(obj)).then((result) => {
              if (result.success) {

                idGarantiaExcepcion.current = result.data.id_garantia_excepcion;
                if (file) {
                  uploadSustento();
                }
                setIsLoading(false);
                setIsFinishSave(true);
              } else {
                setIsLoading(false);
                setIsFinishSave(true);
                setMessageError(result.message)
              }
            }).catch((e) => {
              setIsLoading(false);
              setIsFinishSave(true);
              setMessageError(e.message)
            })
        } else {
          //dispara mensaje de errores
          setIsLoading(false);
          setFormikErrorList(errorList);
        }

      }
    })

  const customDrop = useCallback((acceptedFiles) => {
    if (acceptedFiles.length === 0) {
      return;
    }
    setFile(acceptedFiles[0]);
    setFileNameExcepcion(acceptedFiles[0].path)
    setShowMessageUploadLink(false);
  }, []);

  const uploadSustento = useCallback(() => {
    const formData = new FormData();
    formData.append('file', file);

    queryClient.fetchQuery('uploadSustentoExcepcionGarantia',
      () => UploadSustentoExcepcionGarantia(formData, idGarantiaExcepcion.current, user.email)).then((result, response) => {
        if (result.status === 200 && result.data.success) {
          setFile(null);
          setUrlFileExcepcion(result.data.data.url);
          setFileNameExcepcion(result.data.data.file_name);
          setShowMessageUploadLink(true);
          setIsDisabledButtonSave(true);
          setIsDisabledFormInput(true);
        } else {
          setMessageError(result.data.message)
        }
      }).catch((e) => {
        setMessageError(e.message)
      }).finally(() => {
        setIsLoading(false);
        setIsFinishSave(true);
      })
  }, [file, queryClient, user.email])

  const getUrlFileName = () => {
    var fileName = "";

    switch (initDataExceptionQuery?.detalleGarantia.tipo_garantia.codigo) {
      case GARANTIA_TIPO.GAR1_CARTA_FIANZA:
        fileName = initDataExceptionQuery?.detalleGarantia.url_filename_carta_fianza;
        break;
      case GARANTIA_TIPO.GAR0_EFECTIVO:
        fileName = initDataExceptionQuery?.detalleGarantia.url_filename_operacion;
        break;
      default:
        break;
    }

    return fileName;
  }

  return (
    <>
      <PermissionsGate RenderError={() => <Unauthorized />} scopes={[SCOPES.GARANTIAS_EXCEPCION_GARANTIA]} >
        <PageTitle>
          Registro de Excepción
        </PageTitle>
        {(isLoading || isFetchingInitDataException) && !isFinishSave && (
          <>
            <div className="excepcion-garantia-overlay">
              <div className='position-absolute top-50 start-50 translate-middle loader-excepcion'>
                <Loading></Loading>
              </div>
            </div>
          </>
        )}

        {(!isLoading || !isFetchingInitDataException) && isFinishSave && (
          messageError ? (
            <Alert key='error' variant='primary'>
              <b>ERROR</b>: {messageError}
            </Alert>
          ) : (
            <Alert key='success' variant='success'>
              <b>INFORMACIÓN</b>: La Excepción se ha guardado exitosamente.
            </Alert>
          )
        )}
        {formikErrorList.length > 0 && (
          <Alert key='warning' variant='warning' className="mb-7">
            <b>ADVERTENCIA</b>: Se encontraron las siguientes observaciones al registrar la Excepción:
            <ul className="border mt-3 mb-0">
              {formikErrorList.map((item, index) => (
                <li key={index} className="d-flex align-items-center pb-2">
                  <i className="fi fi-rr-triangle-warning me-3 text-warning"></i>
                  <b>{item.field}:&nbsp;</b> {item.message}
                </li>
              ))}
            </ul>
          </Alert>
        )}
        <div className="row my-5">
          <div className="col-12">
            <button
              type="button"
              className="btn btn-sm btn-primary me-2"
              onClick={() => handleSubmitFormik()}
              disabled={isLoading || isFetchingInitDataException || isDisabledButtonSave}>
              <i className="fi fi-rr-disk fs-3"></i> Registrar Excepción
            </button>
          </div>
        </div>
        <Accordion defaultActiveKey={['0']} alwaysOpen className="max-width-1080">
          <Accordion.Item eventKey="0">
            <Accordion.Header><i className="fi fi-rr-ballot-check fs-3 me-2"></i><span className="fs-4">Contrato N&#176; {initDataExceptionQuery?.garantia.nro_contrato}</span></Accordion.Header>
            <Accordion.Body>
              <div className="row">
                <div className="col-12 col-xl-6">
                  <div className="row mb-6 align-items-center">
                    <div className="col-12 mb-2 mb-sm-0 text-sm-end container-label">
                      <label className="fs-5 fw-bold">Ruc</label>
                    </div>
                    <div className="col-12 col-sm w-sm-100">
                      <span className='ms-6'>{initDataExceptionQuery?.garantia.ruc}</span>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-xl-6">
                  <div className="row mb-6 align-items-center">
                    <div className="col-12 mb-2 mb-sm-0 text-sm-end container-label">
                      <label className="fs-5 fw-bold ">Razon Social</label>
                    </div>
                    <div className="col-12 col-sm w-sm-100">
                      <span className='ms-6'>{initDataExceptionQuery?.garantia.razon_social}</span>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-xl-6">
                  <div className="row mb-6 align-items-center">
                    <div className="col-12 mb-2 mb-sm-0 text-sm-end container-label">
                      <label className="fs-5 fw-bold ">Nombre Comercial</label>
                    </div>
                    <div className="col-12 col-sm w-sm-100">
                      <span className='ms-6'>{initDataExceptionQuery?.garantia.nombre_comercial}</span>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-xl-6">
                  <div className="row mb-6 align-items-center">
                    <div className="col-12 mb-2 mb-sm-0 text-sm-end container-label">
                      <label className="fs-5 fw-bold ">Mall</label>
                    </div>
                    <div className="col-12 col-sm w-sm-100">
                      <span className='ms-6'>{initDataExceptionQuery?.garantia.mall.nombre}</span>
                    </div>
                  </div>
                </div>

              </div>

            </Accordion.Body>
          </Accordion.Item >
          <Accordion.Item eventKey="1">
            <Accordion.Header>
              {initDataExceptionQuery?.detalleGarantia?.tipo_garantia?.codigo === GARANTIA_TIPO.GAR1_CARTA_FIANZA
                && <><i className="fi fi-rr-file-invoice-dollar fs-3 me-2"></i><span className="fs-4">Carta Fianza</span></>
              }

              {initDataExceptionQuery?.detalleGarantia?.tipo_garantia?.codigo === GARANTIA_TIPO.GAR0_EFECTIVO
                && <><i className="fi fi-rr-file-invoice-dollar fs-3 me-2"></i><span className="fs-4">Operación en Efectivo</span></>
              }
            </Accordion.Header>
            <Accordion.Body>
              <div className="row">
                <div className='col-12 col-xl-6'>
                  {initDataExceptionQuery?.detalleGarantia.tipo_garantia?.codigo === GARANTIA_TIPO.GAR1_CARTA_FIANZA ? (
                    <div className='row mb-6 align-items-center'>
                      <div className='col-12 mb-2 mb-sm-0 text-sm-end container-label'>
                        <label className='fs-5 fw-bold '>Nro Carta Fianza</label>
                      </div>
                      <div className='col-12 col-sm w-sm-100'>
                        <a href={getUrlFileName()} target='_blank' className='ms-6' rel="noreferrer"><i className="fi fi-rr-download fs-4"></i> {initDataExceptionQuery?.detalleGarantia.nro_carta_fianza}</a>

                      </div>
                    </div>
                  ) : initDataExceptionQuery?.detalleGarantia.tipo_garantia?.codigo === GARANTIA_TIPO.GAR0_EFECTIVO ? (
                    <div className='row mb-6 align-items-center'>
                      <div className='col-12 mb-2 mb-sm-0 text-sm-end container-label'>
                        <label className='fs-5 fw-bold '>Nro Operaci&oacute;n</label>
                      </div>
                      <div className='col-12 col-sm w-sm-100'>
                        <a href={getUrlFileName()} target='_blank' className='ms-6' rel="noreferrer"><i className="fi fi-rr-download fs-4"></i> {initDataExceptionQuery?.detalleGarantia.nro_operacion}</a>
                      </div>
                    </div>
                  ) : null}
                </div>
                {initDataExceptionQuery?.detalleGarantia.tipo_garantia?.codigo === GARANTIA_TIPO.GAR1_CARTA_FIANZA && (
                  <div className='col-12 col-xl-6'>
                    <div className='row mb-6 align-items-center'>
                      <div className='col-12 mb-2 mb-sm-0 text-sm-end container-label'>
                        <label className='fs-5 fw-bold '>Vigencia</label>
                      </div>
                      <div className='col-12 col-sm w-sm-100'>
                        <span className='ms-6'>
                          {initDataExceptionQuery?.detalleGarantia.fecha_emision_carta_fianza && initDataExceptionQuery?.detalleGarantia.fecha_vencimiento_carta_fianza && `${moment(initDataExceptionQuery?.detalleGarantia.fecha_emision_carta_fianza).format("DD/MM/yyyy")} - ${moment(initDataExceptionQuery?.detalleGarantia.fecha_vencimiento_carta_fianza).format("DD/MM/yyyy")}`}
                        </span>
                      </div>
                    </div>
                  </div>
                )}
                <div className='col-12 col-xl-6'>
                  <div className='row mb-6 align-items-center'>
                    <div className='col-12 mb-2 mb-sm-0 text-sm-end container-label'>
                      <label className='fs-5 fw-bold '>Importe</label>
                    </div>
                    <div className='col-12 col-sm w-sm-100'>
                      <span className='ms-6'>{initDataExceptionQuery?.garantia.moneda.codigo} {numeral(initDataExceptionQuery?.detalleGarantia.importe).format('0,0.00')}</span>
                    </div>
                  </div>
                </div>
                <div className='col-12 col-xl-6'>
                  <div className='row mb-6 align-items-center'>
                    <div className='col-12 mb-2 mb-sm-0 text-sm-end container-label'>
                      <label className='fs-5 fw-bold '>Banco</label>
                    </div>
                    <div className='col-12 col-sm w-sm-100'>
                      <span className='ms-6'>{initDataExceptionQuery?.detalleGarantia.banco.nombre}</span>
                    </div>
                  </div>
                </div>
              </div>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="2">
            <Accordion.Header>
              <i className="fi fi-rr-ballot-check fs-3 me-2"></i><span className="fs-4">Datos de la Excepción</span>
            </Accordion.Header>
            <Accordion.Body>
              <div className="row max-width-xl-1160">

                <div className="col-12 col-xl-6">
                  <div className="row mb-6 align-items-center">
                    <div className="col-12 mb-2 mb-sm-0 text-sm-end container-label">
                      <label className="fs-5 fw-bold ">Tipo de Excepción</label>
                    </div>
                    <div className="col-12 col-sm w-sm-100 max-width-lg-400">
                      <Select classNamePrefix='filter'
                        components={makeAnimated()}
                        value={formikValues.tipoExcepcion}
                        isMulti={false}
                        closeMenuOnSelect={true}
                        options={initDataExceptionQuery?.exceptionTypeList}
                        placeholder="Selecciona"
                        onChange={(e) => setFormikFieldValue(`tipoExcepcion`, e)}
                        isDisabled={isDisabledFormInput}
                      />
                    </div>
                  </div>
                </div>
                {formikValues.tipoExcepcion?.value === 'CFE' ?  
                <div className="col-12 col-xl-6 ">
                  <div className="row mb-6 align-items-center">
                    <div className="col-12 mb-2 mb-sm-0 text-sm-end container-label">
                      <label className="fs-5 fw-bold ">N° Factura</label>
                    </div>
                    <div className="col-12 col-sm w-sm-100 max-width-lg-400">
                      <input
                        type="text"
                        className="form-control form-control-solid"
                        value={formikValues.numfactura}
                        onChange={e => setFormikFieldValue('numfactura', e.target.value)}
                      />
                    </div>
                  </div>
                </div>
                : ''}
              </div>
              <div className="row max-width-xl-1160">
                <div className="col-12 col-xl-6">
                  <div className="row mb-6 align-items-center">
                    <div className="col-12 mb-2 mb-sm-0 text-sm-end container-label">
                      <label className="fs-5 fw-bold ">Importe</label>
                    </div>
                    <div className="col-12 col-sm w-sm-100 max-width-lg-400">
                      <ReactNumeric
                        className="form-control form-control-solid"
                        value={formikValues.importe}
                        decimalCharacter="."
                        digitGroupSeparator=","
                        disabled={isDisabledFormInput}
                        onChange={(e, value) => setFormikFieldValue(`importe`, parseFloat(value || 0))}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-12 col-xl-6">
                  <div className="row mb-6 align-items-center">
                    <div className="col-12 mb-2 mb-sm-0 text-sm-end container-label">
                      <label className="fs-5 fw-bold ">Moneda</label>
                    </div>
                    <div className="col-12 col-sm w-sm-100 max-width-lg-400">
                      <Select classNamePrefix='filter'
                        components={makeAnimated()}
                        value={formikValues.moneda}
                        isMulti={false}
                        closeMenuOnSelect={true}
                        options={initDataExceptionQuery?.monedaList}
                        placeholder="Selecciona"
                        onChange={(e) => {
                          setFormikFieldValue(`moneda`, e)
                        }}
                        isDisabled={isDisabledFormInput}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-12 col-xl-6">
                  <div className="row mb-6 align-items-center ">
                    <div className="col-12 mb-2 mb-sm-0 text-sm-end container-label">
                      <label className="fs-5 fw-bold ">Fecha de Venc.</label>
                    </div>
                    <div className="col-12 col-sm w-sm-100">
                      <DatePicker
                        className="form-control form-control-solid pe-5 text-start"
                        selectsRange={false}
                        locale="es"
                        selected={formikValues.fechaLimite}
                        dateFormat="dd/MM/yyyy"
                        shouldCloseOnSelect={false}
                        onChange={(date) => setFormikFieldValue(`fechaLimite`, date)}
                        placeholderText={""}
                        showMonthDropdown={true}
                        showYearDropdown={true}
                        dropdownMode="select"
                        disabled={isDisabledFormInput}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-12 col-xl-6">
                  <div className="row mb-6 align-items-center">
                    <div className="col-12 mb-2 mb-sm-0 text-sm-end container-label">
                      <label className="fs-5 fw-bold ">Motivo</label>
                    </div>
                    <div className="col-12 col-sm w-sm-100 max-width-lg-400">
                      <textarea
                        className="form-control form-control-solid"
                        rows="2"
                        value={formikValues.motivo}
                        onChange={(e) => setFormikFieldValue(`motivo`, e.target.value)}
                        disabled={isDisabledFormInput}
                      />
                    </div>
                  </div>
                </div>

              </div>


            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="3">
            <Accordion.Header><i className="fi fi-rr-clip fs-3 me-2"></i><span className="fs-4">Sustento de Excepción</span></Accordion.Header>
            <Accordion.Body>
              <div className='row'>
                <UploadZone
                  onDrop={customDrop}
                  fileUrl={urlFileExcepcion}
                  fileName={fileNameExcepcion}
                  isLoading={false}
                  showMessageUploadLink={showMessageUploadLink}
                  fileAccept={'msg'}
                  isDisabled={isDisabledFormInput}
                >
                </UploadZone>
              </div>
            </Accordion.Body>
          </Accordion.Item>


        </Accordion>
      </PermissionsGate >

    </>
  )
}